import { render } from "./PaperList.vue?vue&type=template&id=6446c44e"
import script from "./PaperList.vue?vue&type=script&lang=js"
export * from "./PaperList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/Components/PaperList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6446c44e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6446c44e', __exports__)) {
    api.reload('6446c44e', __exports__)
  }
  
  module.hot.accept("./PaperList.vue?vue&type=template&id=6446c44e", () => {
    api.rerender('6446c44e', render)
  })

}


export default __exports__